import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import NotificationBell from "./NotificationBell";

export default function MobileHeader({
    title,
    subtitle,
    avatar,
    backTo,
    showBell = true,
    variant = "purple",
    children,
}) {
    const nav = useNavigate();
    const grad = variant === "blue" ? "gradient-business" : variant === "navy" ? "gradient-admin-sidebar" : variant === "emerald" ? "gradient-emerald" : variant === "amber" ? "gradient-amber" : "gradient-consumer";
    return (
        <div className={`relative ${grad} gradient-noise px-5 pt-12 pb-6 text-white`}>
            <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                    {backTo !== undefined && (
                        <button
                            onClick={() => nav(backTo || -1)}
                            data-testid="header-back-btn"
                            className="size-9 rounded-full bg-white/15 backdrop-blur flex items-center justify-center tap-feedback"
                        >
                            <ChevronLeft size={20} />
                        </button>
                    )}
                    <div className="min-w-0">
                        {subtitle && <div className="text-xs text-white/70 mb-0.5">{subtitle}</div>}
                        {title && <div className="font-display text-xl font-semibold truncate">{title}</div>}
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    {showBell && <NotificationBell variant="dark" testid="mobile-header-bell" />}
                    {avatar && (
                        <img
                            src={avatar}
                            alt=""
                            className="size-10 rounded-full ring-2 ring-white/40 object-cover"
                            data-testid="header-avatar"
                        />
                    )}
                </div>
            </div>
            {children}
        </div>
    );
}
